import client from 'api/apiClient';
import { sortByField } from 'utils/helpers';

export const fetchStaffList = async (companyId: number, setStatus: string) => {
    try {
        const response: any = await client.get('/merchant/getEmployees', {
            headers: {
                companyId,
                setStatus,
            },
        });
        const sortedEmployees = sortByField(response?.employees || [], 'createdDate', 'DESC');
        return sortedEmployees;
    } catch (error) {
        console.log('basket Activity Error', error);
    }
};
